define("js/utils/has-js",[],function(){"use strict";document.querySelector("html").classList.add("has--js")});
